module.exports = __webpack_public_path__ + "img/windows.bfc23ab1.svg";